module.exports = __webpack_public_path__ + "img/signageboard.3bb32350.png";